var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-2-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75 14.6675H4.81066L11.7959 7.68222L10.7353 6.62155L3.75 13.6069V14.6675ZM15.75 16.1675H2.25V12.9856L12.3263 2.90925C12.6192 2.61635 13.094 2.61635 13.3869 2.90925L15.5083 5.03056C15.8012 5.32346 15.8012 5.79833 15.5083 6.09123L6.93198 14.6675H15.75V16.1675ZM11.7959 5.5609L12.8566 6.62155L13.9172 5.5609L12.8566 4.50024L11.7959 5.5609Z",
    fill: "#296CED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLine);
export default __webpack_public_path__ + "static/media/edit-line.6eb105ffc35c1a38de7ac1766a0a9fb0.svg";
export { ForwardRef as ReactComponent };